(function (angular) {
    'use strict';

    angular.module('app')
        .controller('buyMemberPackageController', buyMemberPackageController);

    buyMemberPackageController.$inject = [
        '$uibModalInstance',
        'memberPackageId',
        'thisUser',
        'MemberPackagesApi',
        'UsersApi',
        'Users',
        'thisSiteSettings',
        'Auth'
    ];

    function buyMemberPackageController (
        $uibModalInstance,
        memberPackageId,
        thisUser,
        MemberPackagesApi,
        UsersApi,
        Users,
        thisSiteSettings,
        Auth
    ) {
        var vm = this;

        // Properties
        vm.card = {};
        vm.isLoading = true;
        vm.loadingMessage = 'Loading...';
        vm.orderConfirmed = false;
        vm.orderPurchased = false;
        vm.thisUser = thisUser;
        vm.thisSiteSettings = thisSiteSettings;
        vm.currencySymbol = thisSiteSettings.currency_symbol;

        // Methods
        vm.close = close;
        vm.confirmOrder = confirmOrder;
        vm.purchaseOrder = purchaseOrder;

        function close() {
            $uibModalInstance.close();
        }

        /**
         * Confirm the order.
         *
         * @return {void}
         */
        function confirmOrder() {
            if (vm.package.payment_required && vm.thisUser.role !== 'admin') {
                Users.manageCard().result.then(function (card) {
                    if (card) {
                        vm.card = card;
                        vm.orderConfirmed = true;
                    }
                });
            } else {
                vm.card = false;
                vm.orderConfirmed = true;
            }
        }

        /**
         * Purchase the member packages.
         *
         * @return {void}
         */
        function purchaseOrder() {
            vm.loadingMessage = 'Purchasing...';
            vm.isLoading = true;
            vm.orderPurchased = false;
            vm.orderPurchaseFailed = false;
            var stripeId = null;

            if (vm.package.payment_required && vm.thisUser.role !== 'admin') {
                stripeId = vm.card && vm.card.stripe_id;
            }

            UsersApi.postMemberPackages({
                id: vm.thisUser.id,
                package_id: memberPackageId,
                stripe_id: stripeId,
            }, function (response) {
                vm.isLoading = false;
                vm.orderPurchased = true;
                vm.userPackage = response.data;
                vm.userPackageExpires = window.moment(response.data.expires_at).toDate();
            }, function () {
                vm.isLoading = false;
                vm.orderPurchaseFailed = true;
            });
        }

        /**
         * Get information about a member package.
         *
         * @return {void}
         */
        function getMemberPackage() {
            vm.isLoading = true;
            vm.loadingMessage = 'Loading member package...';

            MemberPackagesApi.get({id: memberPackageId}, function (response) {
                vm.isLoading = false;
                vm.package = response.data;
            });
        }

        // make sure the user is signed in before showing them the goods
        Auth.check().then(getMemberPackage);
    }

}(angular));